module.exports = __webpack_public_path__ + "static/img/bg-collaboration.56e99f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingpage/bg-collaboration.jpg
// module id = 6+44
// module chunks = 6